// extracted by mini-css-extract-plugin
export var closeButton = "_5-1";
export var container = "_5-0";
export var fullModalImage = "_5-2";